import writeXlsxFile from "write-excel-file";
import { fetchEstoqueReports } from "../../../../utils/services/portalBoticario";

export async function createXlsxStock(jwt, setFinishExport, idEvent) {
  const schema = [
    {
      column: "Nome",
      type: String,
      value: (data) => data.code,
    },
    {
      column: "Total",
      type: Number,
      value: (data) => data.available,
    },
    {
      column: "Quantidade Utilizada",
      type: Number,
      value: (data) => data.registered,
    },
    {
      column: "Quantidade Disponível",
      type: Number,
      value: (data) => data.remaining,
    },
  ];

  const data = await fetchEstoqueReports(jwt, idEvent);

  const progressBar = document.querySelector(".export-progress");
  const percentageBar = document.querySelector(".export-percentage");
  if (progressBar) progressBar.style.width = "100%";
  if (percentageBar) percentageBar.innerHTML = "100%";

  if (data && data.length > 0) {
    await writeXlsxFile(data, {
      schema,
      fileName: "estoque_boticario_cotas.xlsx",
    });
  }

  setTimeout(() => {
    setFinishExport(true);
  }, 1000);
}
